import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { SpecificationSelectorQuery } from './__generated__/selector_query'
import { SelectedQuery } from './selector_query'
import { useCombobox } from '@/helpers/useCombobox'

type productSpecifications = SpecificationSelectorQuery['productSpecifications']['specifications'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data, loading } = useQuery<SpecificationSelectorQuery>(
    SelectedQuery,
  )
  const { pageInfo, items } = useCombobox<productSpecifications>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: data?.productSpecifications.specifications,
    buildSearchable: item => ({
      id: item,
      name: item,
    })
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => false}
      includeBlank={false}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={() => false}
      searchField="nameCont"
      value={items.find(d => d.id == value) || { id: value, name: value }}
      allowCustomInput
      onChange={onChange}
    />
  )
}
